import React from "react";
import { Quotation } from "../../../../stores/CoursePreviewStore/Types";
import { PaymentType, Priceable } from "../../Types";
import LifetimeTermsNote from "./LifetimeTermsNote";
interface TermsNoteProps {
  activeQuote: Quotation;
  monthlySubsequentPayment: string;
  paymentType: PaymentType;
  priceable: Priceable;
  slug: string;
  monthlyTotalAmount: string;
}

const TermsNote: React.FC<TermsNoteProps> = ({
  activeQuote,
  monthlySubsequentPayment,
  monthlyTotalAmount,
  paymentType,
  priceable,
  slug,
}) => {
  if (!activeQuote) return null;

  const amount = `${activeQuote.currency}${activeQuote.formatted_amount}`;

  if (paymentType === "course" || priceable?.type === "course") {
    if (activeQuote.course_payment_plan) {
      return (
        <p className="terms-note" id="termsNote">
          First payment of {amount} today, then{" "}
          {activeQuote.installment_count - 1} monthly payments of{" "}
          {activeQuote.currency}
          {monthlySubsequentPayment || activeQuote.formatted_amount}.
          <br />
          Total: {activeQuote.currency}
          {activeQuote.formatted_total_amount}. By continuing you agree to our{" "}
          <a href="/terms">Terms and Conditions</a>.
        </p>
      );
    }

    return (
      <p className="terms-note" id="termsNote">
        One-off payment of {amount}. Lifetime access to this course, plus 3
        months of Community Hub. By continuing you agree to our{" "}
        <a href="/terms">Terms and Conditions</a>.
      </p>
    );
  }

  if (paymentType === "subscription" || priceable?.type === "pass") {
    if (slug === "lifetime" || priceable?.is_lifetime) {
      return <LifetimeTermsNote amount={amount} />;
    }

    if (slug === "community" || priceable?.is_community) {
      return (
        <p className="terms-note" id="termsNote">
          {amount}/month, billed monthly. Cancel anytime from your account. By
          continuing you agree to our <a href="/terms">Terms and Conditions</a>.
        </p>
      );
    }

    if (priceable?.interval === "month" || activeQuote.interval === "monthly") {
      return (
        <p className="terms-note" id="termsNote">
          First payment of {activeQuote?.currency}
          {activeQuote?.formatted_amount} today, then 11 monthly payments of{" "}
          {activeQuote?.currency}
          {monthlySubsequentPayment}.
          <br />
          Total: {activeQuote?.currency}
          {monthlyTotalAmount}. By continuing you agree to our{" "}
          <a href="/terms">Terms and Conditions</a>.
        </p>
      );
    }

    return (
      <p className="terms-note" id="termsNote">
        One-off payment of {amount}. By continuing you agree to our{" "}
        <a href="/terms">Terms and Conditions</a>.
      </p>
    );
  }

  return null;
};

export default TermsNote;
